import { memo } from 'react'

import FilterSection, { TEST_ID } from './FilterSection'

const FilterSectionComponent = memo(FilterSection)

export { TEST_ID }

export default FilterSectionComponent
